<template>
  <div class="text-date-filter">
    <RInputWithSigns
      ref="input"
      :value="formattedValue"
      :sign="sign"
      @sign-changed="signChanged"
      @clear-filter="clearFilter"
    />
  </div>
</template>

<script>
// Libraries
import Cleave from 'cleave.js'
import { debounce } from 'lodash'
// Components
import RInputWithSigns from '@/ui/RInputWithSigns'

export default {
  name: 'PriceFilter',

  components: {
    RInputWithSigns
  },

  data: () => ({
    formattedValue: null,
    rawValue: null,
    cleave: null,
    previousSign: null,
    sign: 'equal-greater'
  }),

  mounted() {
    const delimiter = this.settings.thousand_separator

    this.cleave = new Cleave(this.$el.querySelector('input'), {
      numeral: true,
      numeralDecimalMark: this.settings.decimal_separator,
      delimiter: delimiter === 'space' ? ' ' : delimiter,
      numeralDecimalScale: 2,
      onValueChanged: debounce(this.valueChanged, 800)
    })
  },

  methods: {
    valueChanged(changedObj, sign = { value: null }) {
      if (!changedObj) {
        this.notifyFilterChange(null, null, sign.value, null)
        this.sign = 'equal-greater'
        return
      }

      const {
        target: { rawValue, value }
      } = changedObj
      const isPreviousValue = !!this.rawValue // we have previous value
      const isCurrentValue = !['', null].includes(rawValue) // we have current value
      const isSign = ![null, 'n/a'].includes(sign.value) // we have sign which is not null or n/a

      if (sign.value === 'n/a') {
        this.notifyFilterChange(null, null, 'n/a', 'n/a')
      } else if ((isPreviousValue && !isCurrentValue) || (this.previousSign === 'n/a' && isSign)) {
        this.notifyFilterChange(null, null, sign.value, null)
      } else if (isCurrentValue) {
        this.notifyFilterChange(rawValue, value, this.sign, Number(rawValue))
      }
    },

    notifyFilterChange(rawValue, formattedValue, comparison, valueForBE) {
      this.previousSign = comparison
      this.rawValue = rawValue
      this.formattedValue = formattedValue

      this.params.parentFilterInstance(function(instance) {
        instance.onFloatingFilterChanged(comparison, valueForBE, 'number')
      })
    },

    clearValue() {
      this.formattedValue = this.rawValue = null
      this.cleave.setRawValue(null)
    },

    clearFilter() {
      this.valueChanged(null)
    },

    signChanged(sign) {
      this.sign = sign.value
      this.valueChanged({ target: { rawValue: this.rawValue, value: this.formattedValue } }, sign)
    },

    onParentModelChanged(parentModel) {
      if (!parentModel) this.clearValue()
      else {
        this.rawValue = parentModel.filter
        this.formattedValue = this.formatPrice(parentModel.filter)
        this.sign = parentModel.type
      }
    }
  }
}
</script>
